import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";

import { Icon } from "@/common/components/primitives/icon";

import styles from "./link.css";

export function Link(props) {
  const {
    children,
    href,
    route,
    target = "_blank",
    className,
    onClick,
    onMouseOver,
    onMouseLeave,
    onFocus,
    onBlur,
    id = "",
    leftIcon,
    rightIcon
  } = props;
  return route ? (
    <RouterLink
      className={`${styles.link} ${className}
        ${(leftIcon || rightIcon) && styles.withicon}
      `}
      to={route}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={onBlur}
      data-component="link"
      id={id}
    >
      {leftIcon && (
        <Icon paddingNone={true} className={styles.leftIcon}>
          {leftIcon}
        </Icon>
      )}
      {children}
      {rightIcon && (
        <Icon paddingNone={true} className={styles.rightIcon}>
          {rightIcon}
        </Icon>
      )}
    </RouterLink>
  ) : (
    <a
      className={`${styles.link} ${className}
        ${(leftIcon || rightIcon) && styles.withicon}
      `}
      href={href}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault();
          onClick(e);
        }
      }}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={onBlur}
      target={target}
      data-component="link"
      id={id}
    >
      {leftIcon && (
        <Icon paddingNone={true} className={styles.leftIcon}>
          {leftIcon}
        </Icon>
      )}
      {children}
      {rightIcon && (
        <Icon paddingNone={true} className={styles.rightIcon}>
          {rightIcon}
        </Icon>
      )}
    </a>
  );
}

Link.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  route: PropTypes.string,
  target: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onMouseOver: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  id: PropTypes.string,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node
};
